import { Routes } from '@angular/router';
import { HomeLayoutComponent } from './home-layout.component';

export function emptyQueryStringMatcher(url: any) {
  if (url.length === 0) {
    return { consumed: url };
  }
  return null;
}

export const HOME_LAYOUT_ROUTES: Routes = [
  {
    path: '',
    component: HomeLayoutComponent,
    children: [
      {
        matcher: emptyQueryStringMatcher,
        redirectTo: 'answer',
        pathMatch: 'full',
      },
      {
        path: 'answer',
        loadComponent: () =>
          import('src/app/pages/answers/answers.component').then(
            (c) => c.AnswersComponent,
          ),
      },
      {
        path: 'favorite-form',
        loadComponent: () =>
          import('src/app/pages/favorite-form/favorite-form.component').then(
            (c) => c.FavoriteFormComponent,
          ),
      },
      {
        path: 'draft',
        loadComponent: ()=>
          import('src/app/pages/drafts/drafts.component').then(
            (c)=>c.DraftsComponent
          )
      }
    ],
  },
];
